var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8011 10.5087C18.0663 10.2214 18.0663 9.77859 17.8011 9.49129L14.8011 6.24129C14.5201 5.93692 14.0457 5.91794 13.7413 6.1989C13.4369 6.47985 13.4179 6.95434 13.6989 7.25871L15.537 9.25L8.75 9.25C8.33579 9.25 8 9.58579 8 10C8 10.4142 8.33579 10.75 8.75 10.75L15.537 10.75L13.6989 12.7413C13.4179 13.0457 13.4369 13.5201 13.7413 13.8011C14.0457 14.0821 14.5201 14.0631 14.8011 13.7587L17.8011 10.5087ZM10 18.25C10 17.8358 9.66421 17.5 9.25 17.5L4.75 17.5C4.05964 17.5 3.5 16.9404 3.5 16.25L3.5 3.75C3.5 3.05964 4.05964 2.5 4.75 2.5L9.25 2.5C9.66421 2.5 10 2.16421 10 1.75C10 1.33579 9.66421 1 9.25 1L4.75 1C3.23122 1 2 2.23122 2 3.75L2 16.25C2 17.7688 3.23122 19 4.75 19L9.25 19C9.66421 19 10 18.6642 10 18.25Z",
    fill: "#272E35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.27995a2ee20cdfde0c4d0c3ca6b0254d.svg";
export { ForwardRef as ReactComponent };